import UserContext from 'src/provider/state-manager/userProvider';
import ApiContext from 'src/provider/API/call-service';
import { useContext, useEffect, useState } from 'react';
import { ScreenContainer, CustomContainer, FlexRow, AppSpan, AppText, Button, Form, FormGroup, FormGroupWithIcon, FlexColumn } from 'src/style';
import { IoMdRefresh } from 'react-icons/io';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { IoAdd } from 'react-icons/io5';
import { MakeTransferD2, Table, TransactionDetailsD2 } from 'src/component';
import { transactionColumns, transactionData } from 'src/utils/tableLayout';
import helpers from 'src/utils/helpers';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';

export const TransactionsD2: React.FC = () => {
    const {API} = useContext(ApiContext)
    const {user: {accountInfo, recentTransactions}} = useContext(UserContext)
    const [input, setInput] = useState({accountNumber: '', startDate: '', endDate: ''})
    const [searchText, setSearchText] = useState('')
    const [transactions, setTransactions] = useState<any>(null)
    const [mockTransactions, setMockTransactions] = useState<any>(null)
    const [txData, setTxData] = useState<any>(null)
    const [view, setView] = useState('')
    const {info:institutionData} = useContext(AppInfoContext)

    useEffect(() => {
        if (recentTransactions?.length) {
            setTransactions(recentTransactions)
            setMockTransactions(recentTransactions)
        }

        if (accountInfo?.length === 1) setInput({...input, accountNumber: accountInfo[0].accountNumber})
    }, [recentTransactions])

    async function fetchTransactions () {
        const response = await API.getTransactions({...input, shouldSendEmail: false})
        if (response) {
            setTransactions(response.isEmailSent ? recentTransactions : response.info.accountStatements)
            setMockTransactions(response.isEmailSent ? recentTransactions : response.info.accountStatements)
        }
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    function handleTextSearch (e: React.ChangeEvent<HTMLInputElement>) {
        setSearchText(e.target.value)
        setMockTransactions(helpers.searchTableData(transactions, e.target.value))
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        fetchTransactions()
    }

    function handleTxDetails (data: any) {
        setTxData(data)
        setView('transaction-details')
    }

    async function handleRefresh () {
        const response = await API.getDashboardData()
        if (response) {
            setTransactions(response[0].accountStatements)
            setMockTransactions(response[0].accountStatements)
            const accountNumber = accountInfo?.length === 1 ? accountInfo[0].accountNumber : ''
            setInput({accountNumber, startDate: '', endDate: ''})
            setSearchText('')
        }
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <CustomContainer
                    customRadius='10px 10px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <FlexRow gap='2.5' justifyContent='space-between'>
                        <CustomContainer>
                            <AppSpan textSize='2.2' fontWeight='700'>Transactions</AppSpan>
                        </CustomContainer>
                        <FlexRow 
                            gap='0.5' width='auto' sizeUnit=''
                            className='refresh-container'
                            onClick={handleRefresh}
                        >
                            <AppSpan 
                                textSize='2' color='#0A756F' cursor='pointer'
                            >
                                <IoMdRefresh />
                            </AppSpan>
                            <AppSpan color='#0A756F' fontWeight='600' topMargin='0.5' cursor='pointer'>Refresh</AppSpan>
                        </FlexRow>
                    </FlexRow>

                    <CustomContainer topMargin='2'>
                        <Form onSubmit={handleProceed}>
                            <FlexRow gap='2' gapUnit='%' wrap='wrap'>
                                <FormGroupWithIcon width='23' className='flight-inputs'>
                                    <label>Source Account</label>
                                    <div className={`input-with-icon ${accountInfo?.length === 1 && 'disabled-input-wrapper'}`}>
                                        <select 
                                            name='accountNumber'
                                            value={input.accountNumber}
                                            style={{color: input.accountNumber ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            disabled={accountInfo?.length === 1 ? true: false}
                                            required
                                        >
                                            <option value="">Select Account</option>
                                            {
                                                accountInfo?.map((item: any, index: number) => {
                                                    return (
                                                        <option value={item.accountNumber} key={index}>{item.accountName} - {item.accountNumber}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                                <FormGroupWithIcon width='23' className='flight-inputs'>
                                    <label>Search</label>
                                    <div className="input-with-icon">
                                        <FiSearch style={{fontSize: '2rem', color: '#667085', marginLeft: '0.5rem'}} className='input-left-icon'/>
                                        <input
                                            name='searchText'
                                            placeholder='Search'
                                            value={searchText}
                                            autoComplete="off"
                                            onChange={handleTextSearch}
                                        />
                                    </div>
                                </FormGroupWithIcon>
                                <FormGroup width='23' className='flight-inputs'>
                                    <label>Start Date</label>
                                    <input 
                                        placeholder='start date' 
                                        type='date'
                                        name='startDate'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.startDate ? '#000000' : '#667085'}}
                                        value={input.startDate}
                                        autoComplete="off"
                                        onChange={handleInput}
                                        required
                                    />
                                </FormGroup>
                                <FormGroup width='23' className='flight-inputs'>
                                    <label>End Date</label>
                                    <input 
                                        placeholder='end date' 
                                        type='date'
                                        name='endDate'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.endDate ? '#000000' : '#667085'}}
                                        value={input.endDate}
                                        autoComplete="off"
                                        onChange={handleInput}
                                        required
                                    />
                                </FormGroup>
                                
                                <FlexRow width='23' sizeUnit='%' className='flight-inputs flight-search-btn'>
                                    <Button 
                                        width='9.1' height='4' topMargin='1' 
                                        borderColor='#0D968F' hoverBgColor='#fff' 
                                        hoverColor='#0D968F' titleSize='1.4'
                                        className='flight-search-btn-d3'
                                    >
                                        Search
                                    </Button>
                                </FlexRow>
                            </FlexRow>
                        </Form>
                    </CustomContainer>

                    <CustomContainer
                        borderColor='#EAECF0' radius='0.8' topMargin='3'
                        shadow='0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
                    >
                        <FlexColumn minHeight='8' padding='2' alignItems='flex-start'>
                            <FlexRow justifyContent='space-between' gap='2' wrap='wrap'>
                                <AppText textSize='1.8' fontWeight='600' color='#101828'>All Transactions</AppText>
                            </FlexRow>
                        </FlexColumn>
                        <Table
                            tableColumns={transactionColumns(handleTxDetails,institutionData?.defaultCurrency)}
                            tableData={mockTransactions}
                            noDataText='No Transactions'
                            noRadius
                            customStyle
                            noDataActionComponent={
                                <Button 
                                    width='16' height='4' topMargin='2' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                    onClick={() => setView('transfer')}
                                >
                                    <IoAdd style={{marginRight: '0.5rem', fontSize: '2rem'}} />
                                    Send Money
                                </Button>
                            }
                        />
                    </CustomContainer>
                </CustomContainer>
            </ScreenContainer>
            { view === 'transaction-details' &&
                <TransactionDetailsD2
                    data={txData}
                    nuban={input?.accountNumber}
                    close={() => setView('')} 
                />
            }
            { view == 'transfer' &&
                <MakeTransferD2 
                    close={() => setView('')} 
                />
            }
        </>
    )
}